import React from "react";
import {Link} from "react-router-dom";
import styles from "./TranscriptPageHeader.module.css";
import {ConversationChannel, UserDTO, BotTranscriptUi} from "../../../../../api/generated";
import {CopyField} from "../../../../elements/copyField/CopyField";
import {ConversationChannelIcon} from "../../../../elements/conversationChannelIcon/ConversationChannelIcon";
import {getBotTypeName} from "../../../assistant/modal/createAndUpdate/components/util/botTypeUtil";

interface TranscriptPageHeaderProps {
    user: UserDTO
    conversationChannel: ConversationChannel
    bot?: BotTranscriptUi
    assistantId?: string
}

export const TranscriptPageHeader: React.FC<TranscriptPageHeaderProps> = ({
                                                                              user,
                                                                              conversationChannel,
                                                                              bot,
                                                                              assistantId
                                                                          }) => {

    const contactInfoMap = [
        {
            title: "Phone Number",
            value: user.phoneNumber
        },
        {
            title: "Email",
            value: user.email
        }
    ]

    return <div className={styles.wrapper}>
        <div className={styles.row}>
            <div className={styles.leftSection}>
                <ConversationChannelIcon conversationChannel={conversationChannel}/>
                <span className={styles.userName}>{user.name ?? "Customer"}</span>
            </div>
            <div className={styles.contactInfoWrapper}>
                {contactInfoMap
                    .map(i => {
                        return <div className={styles.contactInfo}>
                            <span className={styles.contactInfoTitle}>{i.title}</span>
                            <CopyField value={i.value}/>
                        </div>
                    })}
            </div>
        </div>
        {bot && (bot.siteName || bot.botType) && (
            <div className={styles.row}>
                <div className={styles.contactInfoWrapper}>
                    {bot.botType && (
                        <div className={styles.contactInfo}>
                            <span className={styles.contactInfoTitle}>Bot Type</span>
                            <span className={styles.botInfoValue}>{getBotTypeName(bot.botType)}</span>
                        </div>
                    )}
                    {bot.siteName && (
                        <div className={styles.contactInfo}>
                            <span className={styles.contactInfoTitle}>Site Name</span>
                            {assistantId
                                ? <Link className={styles.siteNameLink} to={`/assistants/${assistantId}`}>
                                    {bot.siteName}
                                </Link>
                                : <span className={styles.botInfoValue}>{bot.siteName}</span>}
                        </div>
                    )}
                </div>
            </div>
        )}
    </div>
}
